import React from "react";
import SociosPage from "../Sidebar/SociosComponents/SociosPage";
import PreinscripcionMobile from "../Sidebar/SociosComponents/PreinscripcionMobile";
import { DEMO_DATA } from "./sociosDemoData";

/*
 * Auth-free harnesses for the Figma "Socios" redesign (design-to-code, mock
 * data). No session/backend needed.
 *
 *   /dev/socios          → SociosPage in a plain scrollable frame (no sidebar).
 *   /dev/preinscripcion  → the mobile preinscription form (QR target) in a
 *                          phone bezel.
 * The in-shell variant lives at /dev/socios-shell (real SidebarBest + HeaderNew).
 */
export function SociosDevHarness() {
  return (
    <div style={{ height: "100vh", overflow: "auto", background: "#f5f5f5" }}>
      <SociosPage demo={DEMO_DATA} />
    </div>
  );
}

export function PreinscripcionDevHarness() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#e5e7eb", padding: "24px" }}>
      <div style={{ width: 390, height: 800, maxHeight: "94vh", borderRadius: 40, overflow: "hidden", border: "10px solid #111827", boxShadow: "0 24px 48px rgba(0,0,0,.35)", background: "#fff" }}>
        <PreinscripcionMobile />
      </div>
    </div>
  );
}

export default SociosDevHarness;
